export default {
  remove: function(key: string){
    if (!key) throw 'Local Storage excepts a key to be fetched.';

    try {
      window.localStorage.removeItem(key)
    } catch (e) {
      console.log("Exception:", e)
    }

  },

  get: function (key: string) {
    if (!key) throw 'Local Storage excepts a key to be fetched.';

    let response;
    let item = localStorage.getItem(key);

    try {
      if (item != null) {
        response = JSON.parse(item);
      }
    } catch (e) {
      response = item;
    }

    return response;
  },

  set: function (key: string, value: string) {
    if (typeof value === 'object') {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      localStorage.setItem(key, value);
    }
  },

  clear: function () {
    localStorage.clear();
  }
};
